import React from 'react'
import styles from "./scss/Checkbox.module.scss"

const Checkbox = ({ id, name, label }) => {
  return (
    <div className={styles.checkboxContainer}>
        <input type='checkbox' name={name} id={id} />
        <label htmlFor={id}>{label}</label>
    </div>
  )
}

export default Checkbox